import { ActiveSheetData } from 'src/components/viewers/SheetsViewerV2/hooks/useActiveSheet';
import { PolylineShape } from 'src/components/viewers/SheetsViewerV2/shapes/PolylineShape';
import Viewer3D = Autodesk.Viewing.Viewer3D;
import GuiViewer3D = Autodesk.Viewing.GuiViewer3D;
import Edit2D = Autodesk.Extensions.Edit2D;
import { SheetLineStyleSet } from 'src/components/viewers/SheetsViewerV2/shapes/abstract/AbstractSheetLineShape';

export function mapPointsToPolylineShape(
  pointsArray: THREE.Vector3[][],
  viewer: Viewer3D | GuiViewer3D,
  edit2d: Edit2D,
  activeSheetData: ActiveSheetData,
  styleSet?: SheetLineStyleSet
) {
  return pointsArray.map(
    (points) =>
      new PolylineShape(
        viewer,
        edit2d,
        activeSheetData,
        undefined,
        points,
        styleSet
      )
  );
}
